export default "__VITE_ASSET__CxHm6zZI__"